import { Box, Breadcrumbs, Stack, Typography } from "@mui/material";
export default function PageHeader({
  title,
  description,
  breadcrumbs = [],
  primaryAction,
  secondaryActions,
}) {
  return (
    <Box sx={{ mb: 3 }}>
      {breadcrumbs.length > 0 && (
        <Breadcrumbs aria-label="Breadcrumb" sx={{ mb: 1 }}>
          {breadcrumbs.map((crumb, i) => (
            <Typography key={i} variant="caption" color="text.secondary">
              {crumb}
            </Typography>
          ))}
        </Breadcrumbs>
      )}
      <Stack
        direction={{ xs: "column", sm: "row" }}
        justifyContent="space-between"
        alignItems={{ xs: "stretch", sm: "center" }}
        gap={2}
      >
        <Box sx={{ minWidth: 0 }}>
          <Typography
            component="h1"
            variant="h4"
            sx={{ overflowWrap: "anywhere" }}
          >
            {title}
          </Typography>
          {description && (
            <Typography color="text.secondary" variant="body2" sx={{ mt: 1 }}>
              {description}
            </Typography>
          )}
        </Box>
        {(primaryAction || secondaryActions) && (
          <Stack direction="row" gap={1} flexWrap="wrap">
            {secondaryActions}
            {primaryAction}
          </Stack>
        )}
      </Stack>
    </Box>
  );
}
